import { Injectable } from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {ExcRestService} from 'exc-rest';
import {Observable} from 'rxjs';
import {ModalCommentComponent} from './modals/modal-comment/modal-comment.component';
import {AuditActionResult} from './audit-action-service.service';
import {ModalReportComponent} from './modals/modal-report/modal-report.component';
import {ModalReportEditComponent} from './modals/modal-report-edit/modal-report-edit.component';
import {ExcFileItem} from './attachments/models/ExcFileItem';
import {DataImportUploadConfirmModalComponent} from './data-import-upload-confirm-modal/data-import-upload-confirm-modal.component';
import {DatePipe} from '@angular/common';
import {ModalReportAboEditComponent} from './modals/modal-report-abo-edit/modal-report-abo-edit.component';
import {forEach} from '@angular/router/src/utils/collection';
import {ModalYesNoComponent} from './modals/modal-yes-no/modal-yes-no.component';

@Injectable({
  providedIn: 'root'
})
export class ReportService extends ExcTranslation {

  constructor(private excRest: ExcRestService) {
    super();
  }
  public Edit(r: ExcReport) {
    const _self = this;
    const obs: Observable<ExcReport> = Observable.create( o => {
      ExcCoreModule.showModal(ModalReportEditComponent, null, 'm', {
        Report: r
      }, false).subscribe(mr => {
        if (mr && mr.proceed === true) {
          const url = _self.excRest.computeUrl('ReportR', {rptID: r.rptID});
          _self.excRest.post(url, mr, {}).subscribe(rst => {
            if (rst) {
              r.rptName = rst['rptName'];
              r.rptDescription = rst['rptDescription'];
              r.rptOutputFormats = rst['rptOutputFormats'];
              r.rptDelivery = rst['rptDelivery'];
              o.next(r);
              o.complete();
            } else {
              o.next(null);
              o.complete();
            }
          });
        } else {
          o.next(null);
          o.complete();
        }
      });
    });
    return obs;
  }
  public DownloadTemplate(rptID: number) {
    const _self = this;
    const url = _self.excRest.computeUrl('ReportR_Template', {rptID: rptID});
    window.location.href = url;
  }
  public UploadTemplate(r: ExcReport, f: ExcFileItem) {
    const _self = this;
    const obs: Observable<any> = Observable.create( o => {
      if (f.fullName.indexOf(r.rptTemplateType) === -1) {
        ExcCoreModule.showModal(_self.getTranslation('ModalReportComponent.WrongFileBody'), _self.getTranslation('ModalReportComponent.WrongFileHeader'), 's', null, false, []).subscribe();
        o.next(null);
        o.complete();
      } else {
        const url = _self.excRest.computeUrl('ReportR_Template', {rptID: r.rptID});
        ExcCoreModule.showModal(DataImportUploadConfirmModalComponent, null, 's', f.fullName, false, null).subscribe(dlg => {
          if (dlg && dlg.proceed === true) {
            const formData = new FormData();
            formData.append('file[]', f.asBlob, f.fullName);
            _self.excRest.post(url, formData, {}).subscribe(ret => {
              o.next(ret);
              o.complete();
            });
          } else {
            o.next(null);
            o.complete();
          }
        });
      }
    });
    return obs;
  }
  public ShowModal(Source: string, Identifier?: number) {
    const _self = this;
    const obs: Observable<boolean> = Observable.create( o => {
      const url = _self.excRest.computeUrl('ReportR_List');
      _self.excRest.get(url, {}).subscribe(ret => {
        if (ret) {
          const reports: ExcReport[] = [];
          for (const x of ret['Reports']) {
            reports.push(ExcReport.Parse(x));
          }
          ExcCoreModule.showModal(ModalReportComponent, null, 'l', {Reports: reports, Source: Source, Identifier: Identifier}, false).subscribe(r => {
            if (r && r.proceed === true) {
              if (r['mail'] === undefined) {
                window.open(_self.excRest.computeUrl('ReportR', r), '_blank').focus();
              } else {
                _self.excRest.get(_self.excRest.computeUrl('ReportR', r), {}).subscribe(rep => {
                  if (rep) {
                    ExcCoreModule.showModal(_self.getTranslation('ModalReportComponent.SuccessBody'), _self.getTranslation('ModalReportComponent.SuccessHeader'), 's', null, false, []).subscribe();
                    o.next(true);
                    o.complete();
                  } else {
                    o.next(false);
                    o.complete();
                  }
                });
              }
            }
          });
        } else {
          ExcCoreModule.showModal(_self.getTranslation('ModalReportComponent.NoReportsBody'), _self.getTranslation('ModalReportComponent.NoReportsHeader'), 's', null, false, []).subscribe();
          o.next(false);
          o.complete();
        }
      });
    });
    return obs;
  }
  public ShowAboDeleteModal(abo: ExcReportAbo) {
    const _self = this;
    const obs: Observable<any> = Observable.create( o => {

        ExcCoreModule.showModal(ModalYesNoComponent, null, 's', {Message: _self.getTranslation('ConfigComponent.DeleteAboMessage')}, false, null).subscribe(dlg => {
          if (dlg && dlg.proceed === true) {
            const url = _self.excRest.computeUrl('ReportAbo_D', {rpaID: abo.rpaID});
            _self.excRest.delete(url, {}, {}).subscribe(rep => {
              if (rep) {
                const arr: ExcReportAbo[] = [];
                for (const d of rep.data.Abos) {
                  arr.push(ExcReportAbo.Parse(d));
                }
                o.next(arr);
              } else {
                o.next(null);
              }
              o.complete();
            });
            }
        });
    });
    return obs;
  }
  public ShowAboEditModal(abo: ExcReportAbo, reports: ExcReport[], templates: ExcReportAboTemplate[]) {
    const _self = this;
    const obs: Observable<ExcReportAbo[]> = Observable.create( o => {
        ExcCoreModule.showModal(ModalReportAboEditComponent, null, 'l', {Reports: reports, Abo: abo, Templates: templates}, false).subscribe(r => {
          if (r && r.proceed === true) {
            const url = _self.excRest.computeUrl('ReportAbo_CU');
            _self.excRest.post(url, r.Abo.ToRest(), {}).subscribe(rep => {
              if (rep) {
                const arr: ExcReportAbo[] = [];
                for (const d of rep.Abos) {
                  arr.push(ExcReportAbo.Parse(d));
                }
                o.next(arr);
              } else {
                o.next(null);
              }
              o.complete();
            });
          }
        });
    });
    return obs;
  }
}

export class ExcReport {
  public rptID: number;
  public rptDescription: string;
  public rptName: string;
  public rptOutputFormats: string;
  public rptTargetAudit: boolean;
  public rptTargetDealer: boolean;
  public rptSingleEntity: boolean;
  public rptType: string;
  public rptTimeDriven: boolean;
  public rptDelivery: string;
  public rptTemplateType: string;
  public rptHasTemplate: boolean;
  constructor() {

  }
  isAvailable(source: string): boolean {
    if (source === 'Audit' && this.rptType === 'Audit') {
      return true;
    }
    if (source === 'Dealer' && this.rptType === 'Dealer') {
      return true;
    }
    if (source === 'Dashboard' && this.rptType === 'Summary') {
      return true;
    }
    return false;
  }
  public getIcon(): string {
    switch (this.rptType) {
      case 'Audit':
        return 'fa-clipboard-list-check';
      case 'Dealer':
        return 'fa-car-building';
    }
    return 'fa-sigma';
  }
  public getTooltip(): string {
    switch (this.rptType) {
      case 'Audit':
        return 'Report für ein Audit';
      case 'Dealer':
        return 'Report für einen Händler';
    }
    return 'Summarischer Report';
  }
  public Clone(): ExcReport {
    const r = new ExcReport();
    r.rptDescription = this['rptDescription'];
    r.rptID = this['rptID'];
    r.rptName = this['rptName'];
    r.rptOutputFormats = this['rptOutputFormats'];
    r.rptTargetAudit = this['rptTargetAudit'];
    r.rptTargetDealer = this['rptTargetDealer'];
    r.rptSingleEntity = this['rptSingleEntity'];
    r.rptType = this['rptType'];
    r.rptTimeDriven = this['rptTimeDriven'];
    r.rptDelivery = this['rptDelivery'];
    r.rptTemplateType = this['rptTemplateType'];
    r.rptHasTemplate = this['rptHasTemplate'];
    return r;
  }
  public static Parse(data: any): ExcReport {
    const r = new ExcReport();
    r.rptDescription = data['rptDescription'];
    r.rptID = data['rptID'];
    r.rptName = data['rptName'];
    r.rptOutputFormats = data['rptOutputFormats'];
    r.rptTargetAudit = data['rptTargetAudit'];
    r.rptTargetDealer = data['rptTargetDealer'];
    r.rptSingleEntity = data['rptSingleEntity'];
    r.rptType = data['rptType'];
    r.rptTimeDriven = data['rptTimeDriven'];
    r.rptDelivery = data['rptDelivery'];
    r.rptTemplateType = data['rptTemplateType'];
    r.rptHasTemplate = data['rptHasTemplate'];
    return r;
  }
}
export class ExcReportAboTemplate {
  public rpatID: number;
  public rpatName: string;
  constructor() {
  }
  public static Parse(data: any): ExcReportAboTemplate {
    const x = new ExcReportAboTemplate();
    x.rpatID = data['rpatID'];
    x.rpatName = data['rpatName'];
    return x;
  }
}
export class ExcReportAbo extends ExcTranslation {
  public rpaID: string;
  public rpaCRD: Date;
  public rpa_rptID: number;
  public rpa_rpatID: number;
  public rpaCRU: string;
  public rpaLCU: string;
  public rpaLCD: Date;
  public rpaFormat: string;
  public rpaRecipients: string;
  public rpaRecipientSelfcheck: boolean;
  public rpaRecipientDealer: boolean;
  public rpaMode: string;
  public rpaEvent: string;
  public rpaInterval: string;
  public rpaIntervalTarget: string;
  public rpaIntervalDaytime: string;
  public rpaIntervalSpan: number;
  public rpaIntervalSpanUnit: string;
  public rpaLastSentDate: Date;
  public rpaLastSent_notID: string;
  public rptName: string;
  public rptDescription: string;
  public rptOutputFormats: string;
  constructor() {
      super();
      this.rpaID = null;
      this.rpaCRD = null;
      this.rpa_rptID = null;
      this.rpa_rpatID = null;
      this.rpaCRU = null;
      this.rpaLCU = null;
      this.rpaLCD = null;
      this.rpaFormat = null;
      this.rpaRecipients = null;
      this.rpaRecipientSelfcheck = null;
      this.rpaRecipientDealer = null;
      this.rpaMode = null;
      this.rpaEvent = null;
      this.rpaInterval = null;
      this.rpaIntervalTarget = null;
      this.rpaIntervalDaytime = null;
      this.rpaIntervalSpan = null;
      this.rpaIntervalSpanUnit = null;
      this.rpaLastSentDate = null;
      this.rpaLastSent_notID = null;
      this.rptName = null;
      this.rptDescription = null;
      this.rptOutputFormats = null;
  }
  public getRecipients(): string[] {
    let x: string[] = [];
    if (this.rpaRecipients.length > 0) {
      x = this.rpaRecipients.split(',');
    }
    return x;
  }
  public getFormatTooltip(): string {
    switch (this.rpaFormat.toLowerCase()) {
      case 'xlsx':
        return this.getRessource('FileExcel');
      case 'docx':
        return this.getRessource('FileWord');
      default:
        return this.getRessource('FilePdf');
    }
  }
  public getEventText(): string {
    return this.getRessource('DeliveryAt') + this.getRessource('Event_' + this.rpaEvent);
  }
  public getScheduleText(): string {
    let s = '';
    switch (this.rpaInterval) {
      case 'daily':
        s = this.getRessource('ScheduleDaily', {time: this.rpaIntervalDaytime});
        break;
      case 'weekly':
        s = this.getRessource('ScheduleWeekly1');
        const days: string[] = this.rpaIntervalTarget.split('|');
        s += this.getRessource('Day_' + days[0]);
        if (days.length > 1) {
          for (let i = 1; i < days.length - 1; i++) {
            s += ', ' + this.getRessource('Day_' + days[i]);
          }
          s += ' ' + this.getRessource('And') + ' ' + this.getRessource('Day_' + days[days.length - 1]);
        }
        s += ' ' + this.getRessource('TimeAt', {time: this.rpaIntervalDaytime});
        break;
      case 'monthly':
        if (this.rpaIntervalTarget === 'last' || this.rpaIntervalTarget === 'first') {
          s = this.getRessource('ScheduleMonthly_' + this.rpaIntervalTarget);
        } else {
          s = this.getRessource('ScheduleMonthly_specific', {day: this.rpaIntervalTarget});
        }
        s += ' ' + this.getRessource('TimeAt', {time: this.rpaIntervalDaytime});
        break;
    }
    return s;
  }
  public getTimespanText(): string {
    if (this.rpaIntervalSpan === 0) {
      return this.getRessource('SinceLastReport');
    }
    if (this.rpaIntervalSpan === 1) {
      switch (this.rpaIntervalSpanUnit) {
        case 'day':
          return this.getRessource('TimespanDay', {days: this.rpaIntervalSpan});
        case 'week':
          return this.getRessource('TimespanWeek', {days: this.rpaIntervalSpan});
        case 'month':
          return this.getRessource('TimespanMonth', {days: this.rpaIntervalSpan});
      }
    } else {
      switch (this.rpaIntervalSpanUnit) {
        case 'day':
          return this.getRessource('TimespanDays', {days: this.rpaIntervalSpan});
        case 'week':
          return this.getRessource('TimespanWeeks', {days: this.rpaIntervalSpan});
        case 'month':
          return this.getRessource('TimespanMonths', {days: this.rpaIntervalSpan});
      }
    }
  }
  public getFormatIcon(): string {
    switch (this.rpaFormat.toLowerCase()) {
      case 'xlsx':
        return 'fa-file-excel';
      case 'docx':
        return 'fa-file-word';
      default:
        return 'fa-file-pdf';
    }
  }
  public getAvatarIcon(): string {
    switch (this.rpaMode.toLowerCase()) {
      case 'event':
        return 'fa-bolt';
      case 'schedule':
        return 'fa-clock';
    }
  }
  public getTooltip(): string {
    switch (this.rpaMode.toLowerCase()) {
      case 'event':
        return this.getRessource('ModeEventHint');
      case 'schedule':
        return this.getRessource('ModeScheduleHint');
    }
  }
  public ToRest(): any {
    return {rpaID: this.rpaID
            , rpa_rptID: this.rpa_rptID
            , rpa_rpatID: this.rpa_rpatID
            , rpaRecipients: this.rpaRecipients
            , rpaRecipientsSelfcheck: this.rpaRecipientSelfcheck
            , rpaRecipientsDealer: this.rpaRecipientDealer
            , rpaFormat: this.rpaFormat
            , rpaMode: this.rpaMode
            , rpaEvent: this.rpaEvent
            , rpaInterval: this.rpaInterval
            , rpaIntervalTarget: this.rpaIntervalTarget
            , rpaIntervalDaytime: this.rpaIntervalDaytime
            , rpaIntervalSpan: this.rpaIntervalSpan
            , rpaIntervalSpanUnit: this.rpaIntervalSpanUnit};

  }
  public Clone(): ExcReportAbo {
    const r = new ExcReportAbo();
    r.rpaID = this.rpaID;
    r.rpa_rptID = this.rpa_rptID;
    r.rpa_rpatID = this.rpa_rpatID;
    r.rpaCRD = this.rpaCRD;
    r.rpaCRU = this.rpaCRU;
    r.rpaLCU = this.rpaLCU;
    r.rpaLCD = this.rpaLCD;
    r.rpaFormat = this.rpaFormat;
    r.rpaRecipients = this.rpaRecipients;
    r.rpaRecipientDealer = this.rpaRecipientDealer;
    r.rpaRecipientSelfcheck = this.rpaRecipientSelfcheck;
    r.rpaMode = this.rpaMode;
    r.rpaEvent = this.rpaEvent;
    r.rpaInterval = this.rpaInterval;
    r.rpaIntervalTarget = this.rpaIntervalTarget;
    r.rpaIntervalDaytime = this.rpaIntervalDaytime;
    r.rpaIntervalSpan = this.rpaIntervalSpan;
    r.rpaIntervalSpanUnit = this.rpaIntervalSpanUnit;
    r.rpaLastSentDate = this.rpaLastSentDate;
    r.rpaLastSent_notID = this.rpaLastSent_notID;
    r.rptName = this.rptName;
    r.rptDescription = this.rptDescription;
    r.rptOutputFormats = this.rptOutputFormats;
    return r;
  }
  public static Parse(data: any): ExcReportAbo {
    const r = new ExcReportAbo();
    r.rpaID = data['rpaID'];
    r.rpa_rptID = data['rpa_rptID'];
    r.rpa_rpatID = data['rpa_rpatID'];
    r.rpaCRD = data['rpaCRD'];
    r.rpaCRU = data['rpaCRU'];
    r.rpaLCU = data['rpaLCU'];
    r.rpaLCD = data['rpaLCD'];
    r.rpaRecipients = data['rpaRecipients'];
    r.rpaRecipientDealer = data['rpaRecipientDealer'];
    r.rpaRecipientSelfcheck = data['rpaRecipientSelfcheck'];
    r.rpaFormat = data['rpaFormat'];
    r.rpaMode = data['rpaMode'];
    r.rpaEvent = data['rpaEvent'];
    r.rpaInterval = data['rpaInterval'];
    r.rpaIntervalTarget = data['rpaIntervalTarget'];
    r.rpaIntervalDaytime = data['rpaIntervalDaytime'];
    r.rpaIntervalSpan = data['rpaIntervalSpan'];
    r.rpaIntervalSpanUnit = data['rpaIntervalSpanUnit'];
    r.rpaLastSentDate = data['rpaLastSentDate'];
    r.rpaLastSent_notID = data['rpaLastSent_notID'];
    r.rptName = data['rptName'];
    r.rptDescription = data['rptDescription'];
    r.rptOutputFormats = data['rptOutputFormats'];
    return r;
  }
  public IsEqual(r: ExcReportAbo): boolean {
    return r.rpaID  === this.rpaID &&
    r.rpa_rptID  === this.rpa_rptID &&
      r.rpa_rpatID  === this.rpa_rpatID &&
    r.rpaCRD  === this.rpaCRD &&
    r.rpaCRU  === this.rpaCRU &&
    r.rpaLCU  === this.rpaLCU &&
    r.rpaLCD  === this.rpaLCD &&
    r.rpaRecipients  === this.rpaRecipients &&
    r.rpaRecipientDealer  === this.rpaRecipientDealer &&
    r.rpaRecipientSelfcheck  === this.rpaRecipientSelfcheck &&
    r.rpaFormat  === this.rpaFormat &&
    r.rpaMode  === this.rpaMode &&
    r.rpaEvent  === this.rpaEvent &&
    r.rpaInterval  === this.rpaInterval &&
    r.rpaIntervalTarget  === this.rpaIntervalTarget &&
    r.rpaIntervalDaytime  === this.rpaIntervalDaytime &&
    r.rpaIntervalSpan  === this.rpaIntervalSpan &&
    r.rpaIntervalSpanUnit  === this.rpaIntervalSpanUnit &&
    r.rpaLastSentDate  === this.rpaLastSentDate &&
    r.rpaLastSent_notID  === this.rpaLastSent_notID &&
    r.rptName  === this.rptName &&
    r.rptDescription  === this.rptDescription &&
    r.rptOutputFormats  === this.rptOutputFormats;
  }
}
